var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagerChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76 101",
    style: {
      enableBackground: "new 0 0 76 101"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    className: "st1",
    d: "M31.6,50.5h15.6v-5.3c0-1.2-1-2.2-2.2-2.2H13.2C12,43,11,43.9,11,45.2v21.6c0,0.2,0,0.3,0,0.5v7.4L21.2,69h6.5 V54.3C27.7,52.2,29.4,50.5,31.6,50.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7B7A7A",
    className: "st2",
    d: "M68,66.5v-12c0-1.2-1-2.2-2.2-2.2h-7.7c-0.1,3.6,4.3,7.1,3.2,10.4c0.5,0.5,0.7,1.3,0.7,2c0,1.7-1.3,3.1-3,3.3 c-1.8,3.4-6.1,6.5-8.8,9.2h7.7L68,83V66.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    className: "st3",
    d: "M59,68c-0.1,0-0.3,0-0.4,0c-1.9,0-3.4-1.5-3.4-3.3c0-1.9,1.5-3.3,3.4-3.3c1.1,0,2.1,0.5,2.7,1.3 c1.1-3.3,1.7-6.8,1.8-10.4H49.3H31.8c-1.2,0-2.2,1-2.2,2.2V71v4c0,1.2,1,2.2,2.2,2.2h20.3C54.8,74.5,57.2,71.5,59,68z M39,68.1 c-1.9,0-3.4-1.5-3.4-3.3c0-1.9,1.5-3.3,3.4-3.3s3.4,1.5,3.4,3.3C42.4,66.6,40.9,68.1,39,68.1z M49.3,68c-0.2,0-0.4,0-0.5,0 c-1.9,0-3.4-1.5-3.4-3.3c0-1.9,1.5-3.3,3.4-3.3c0.2,0,0.4,0,0.5,0c1.6,0.3,2.9,1.6,2.9,3.3C52.2,66.4,51,67.8,49.3,68z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "st4",
    d: "M48.8,68.5c2.1,0,3.8-1.7,3.8-3.7s-1.7-3.7-3.8-3.7S45,62.8,45,64.8C45,66.8,46.7,68.5,48.8,68.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "st4",
    d: "M39,68.5c2.1,0,3.8-1.7,3.8-3.7s-1.7-3.7-3.8-3.7s-3.8,1.7-3.8,3.7S36.9,68.5,39,68.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "st4",
    d: "M58.6,68.5c2.1,0,3.8-1.7,3.8-3.7s-1.7-3.7-3.8-3.7s-3.8,1.7-3.8,3.7S56.5,68.5,58.6,68.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerChat);
export default __webpack_public_path__ + "static/media/manager-chat.3c6680c4f6d976b33d0f1a57bbc23c59.svg";
export { ForwardRef as ReactComponent };